module.exports = __webpack_public_path__ + "img/icon_plus-b.f605a213.svg";